import React from 'react'
import ContactUs from './common/ContactUs'
import { Card, CardGroup, Container,Row, Col } from 'react-bootstrap'

const ContactUsPage = () => {
    return (
        <>
            <div className="contact-us-page vh-100">
                <Container className='align-content-center vh-100 justify-content-center align-items-center d-flex text-white'>
                    <CardGroup className='position-relative justify-content-center align-items-center d-flex rounded-5'>
                        <Card bg="primary" className=' bg-gradient h-auto px-5 my-5 align-self-lg-stretch'>
                            <Card.Body className='py-5 my-5'>
                            <h1 className="font-weight-light text-center py-3\2 fw-bolder">Feel free to connect with</h1>
                            <h2 className='font-weight-light text-center py-1 fw-bolder text-bg-primary rounded-1'>3D Training</h2>
                            {/* <Card.Text> */}
                            <p className="mx-2 my-3 py-2 contact-us-page-content">We welcome your inquiries! Please use the space below to share your message, along with your contact information and interests. Our team is committed to swift responses. Thank you for getting in touch!</p>
                            {/* </Card.Text> */}
                            </Card.Body>
                        </Card>
                        <Card bg="primary" className=' bg-gradient h-auto px-5 my-5'>
                            <Card.Body className='py-5 my-5'>
                                <h1 className="font-weight-light text-center mt-2 fw-bolder">Contact Us</h1>
                                <ContactUs />
                            </Card.Body>
                        </Card>
                    </CardGroup>
                </Container>
            </div>
           
        </>
    )
}

export default ContactUsPage